import 'phaser'
import { perlin } from '../demo/perlin-sidecar'
import { common } from './common-sidecar'
import { preloader } from './preloader-sidecar'
import { scene } from './scene-sidecar'

const w = window.innerWidth
const h = window.innerHeight
export const config = {
  type: Phaser.AUTO,
  mode: Phaser.NONE,
  backgroundColor: '#125555',
  width: w,
  height: h,
  scene: {
    preload: preload,
    create: create,
    update: update,
    pack: {
      files: [
        // {
        //   type: 'scenePlugin',
        //   key: 'SpinePlugin',
        //   url: 'plugins/SpinePlugin.js',
        //   sceneKey: 'spine',
        // },
      ],
    },
  },
  parent: 'phaser-root',
  pixelArt: true,
  input: {
    gamepad: false,
  },
}

export const game = new Phaser.Game(config)

window.addEventListener(
  'resize',
  (event) => {
    game.scale.resize(window.innerWidth, window.innerHeight)
  },
  false,
)

function preload() {
  let load = this.load

  preloader.preloadAssets(this.load)
}

function create() {
  game.canvas.oncontextmenu = (ev) => {
    ev.preventDefault()
  }

  common.setPhaserScene(this)

  scene.create()

  // demoPerlin()
}

function demoPerlin() {
  perlin.create()
}

function update(time: number, delta: number) {
  scene.update(time, delta)
}
